import CryptoJS from "crypto-js";
import generatePassword from "generate-password";

const secretEncryptKey = "PrHzpAV3eSNx+r9Krkc1JDZQmo2dbANE2pwBes3zZOYT6JRWPCDS4HUD";
const validateMinutes = 15;
const BG_TIME_ZONE = 'Europe/Sofia';

export function encryptUrlSegment(text) {
	const encrypted = CryptoJS.AES.encrypt(text, secretEncryptKey).toString();
	return encodeURIComponent(encrypted);
}

export function decryptUrlSegment(encryptedText) {
	const decryptedBytes = CryptoJS.AES.decrypt(decodeURIComponent(encryptedText), secretEncryptKey);
	return decryptedBytes.toString(CryptoJS.enc.Utf8);
}

export function getExpirationPeriod() {
	const currentDate = new Date();

	const bulgariaDate = new Date(currentDate.toLocaleString('en-US', { timeZone: BG_TIME_ZONE }));
	bulgariaDate.setMinutes(bulgariaDate.getMinutes() + validateMinutes);

	const year = bulgariaDate.getFullYear();
	const month = String(bulgariaDate.getMonth() + 1).padStart(2, '0');
	const day = String(bulgariaDate.getDate()).padStart(2, '0');
	const hours = String(bulgariaDate.getHours()).padStart(2, '0');
	const minutes = String(bulgariaDate.getMinutes()).padStart(2, '0');
	const seconds = String(bulgariaDate.getSeconds()).padStart(2, '0');
	const milliseconds = String(bulgariaDate.getMilliseconds()).padStart(3, '0').padEnd(6, '0');

	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
}

export function isNotExpired(expirationPeriod) {
	const inputDateTime = new Date(expirationPeriod);
	const currentDateTime = new Date(new Date().toLocaleString('en-US', { timeZone: BG_TIME_ZONE }));

	return inputDateTime >= currentDateTime;
}

export function generateNewPassword() {
	return generatePassword.generate({
		length: 14,
		numbers: true,
		symbols: true,
		uppercase: true,
		lowercase: true
	});
}

export function getResetPasswordData(token) {
	const password = generateNewPassword();
	const expirationTime = getExpirationPeriod();

	const uri = `${encryptUrlSegment(password)}/${encryptUrlSegment(expirationTime)}/${encryptUrlSegment(token)}`;

	return {
		uri,
		password,
		token
	}
}
